var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{attrs:{"animated":"","variant":"success","value":this.downloadPercentage,"height":"2rem","width":"10rem"}}),_c('div',{staticClass:"progress-text"},[_vm._v(_vm._s(this.downloadStatusText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }